import { PropsWithChildren } from 'react';
import styles from './Container.module.css';
import { HasClassName } from '~/types/HasClassName';
import classNames from 'classnames';

export type ContainerWidth = 'narrow' | 'default';

type Props = PropsWithChildren &
  HasClassName & {
    as?: 'main' | 'section' | 'div';
    width?: ContainerWidth;
  };

export function Container({ children, className, width = 'default', as: Component = 'div' }: Props) {
  return (
    <Component className={classNames(styles.container, styles[`width-${width}`], className)}>{children}</Component>
  );
}
